import 'css-chunksrc/client/scenes/resourcesListingConfiguration/form/styles.scss';export default {
  "form": "_form_1o4z8_1",
  "group": "_group_1o4z8_5",
  "row": "_row_1o4z8_9",
  "label": "_label_1o4z8_19",
  "description": "_description_1o4z8_24",
  "roleSelection": "_roleSelection_1o4z8_28"
};